// extracted by mini-css-extract-plugin
export var gif = "_l5-0";